"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequirementInstanceResultSchema = exports.RequirementResultTypeDisplayNames = exports.RequirementResultTypeSchema = exports.AnalysisResultTypeSchema = exports.RequirementResultType = void 0;
const zod_1 = require("zod");
const DesignObject_1 = require("./DesignObject");
const RequirementInstanceResultStatus_1 = require("./RequirementInstanceResultStatus");
const RequirementInstanceResultOverrideStatus_1 = require("./RequirementInstanceResultOverrideStatus");
const RequirementInstanceResults_1 = require("./RequirementInstanceResults");
const RequirementInstanceNote_1 = require("./RequirementInstanceNote");
var RequirementResultType;
(function (RequirementResultType) {
    RequirementResultType["NetDrive"] = "LOGIC";
    RequirementResultType["Pinout"] = "PINS";
    RequirementResultType["BNDS"] = "BNDS";
    RequirementResultType["CVAL"] = "CVAL";
    RequirementResultType["LogicalBus"] = "BUS";
    RequirementResultType["ComponentFunction"] = "CFUN";
    RequirementResultType["ComponentResource"] = "CRES";
})(RequirementResultType || (exports.RequirementResultType = RequirementResultType = {}));
exports.AnalysisResultTypeSchema = zod_1.z.nativeEnum(RequirementResultType);
exports.RequirementResultTypeSchema = zod_1.z.nativeEnum(RequirementResultType);
exports.RequirementResultTypeDisplayNames = {
    [RequirementResultType.NetDrive]: 'Logic Threshold Validation',
    [RequirementResultType.Pinout]: 'Pinout Validation',
    [RequirementResultType.BNDS]: 'Component Limits Validation',
    [RequirementResultType.CVAL]: 'Component Value Validation',
    [RequirementResultType.LogicalBus]: 'Bus Validation',
    [RequirementResultType.ComponentFunction]: 'Component Function Validation',
    [RequirementResultType.ComponentResource]: 'Component Resource Validation',
};
exports.RequirementInstanceResultSchema = zod_1.z.object({
    id: zod_1.z.string(),
    requirementId: zod_1.z.string(),
    typeId: zod_1.z.string().transform((v) => {
        if (v === 'NetDrive') {
            return RequirementResultType.NetDrive;
        }
        if (v === 'Pinout') {
            return RequirementResultType.Pinout;
        }
        if (v === 'LogicalBus') {
            return RequirementResultType.LogicalBus;
        }
        if (v === 'ComponentFunction') {
            return RequirementResultType.ComponentFunction;
        }
        if (v === 'ComponentResource') {
            return RequirementResultType.ComponentResource;
        }
        return exports.AnalysisResultTypeSchema.parse(v);
    }),
    projectId: zod_1.z.string(),
    buildId: zod_1.z.string().optional(),
    expected: zod_1.z.string(),
    actual: zod_1.z.string(),
    status: zod_1.z.lazy(() => RequirementInstanceResultStatus_1.RequirementInstanceResultStatusSchema),
    statusOverride: zod_1.z
        .lazy(() => RequirementInstanceResultOverrideStatus_1.RequirementInstanceResultOverrideStatusSchema)
        .nullable()
        .optional(),
    isReviewed: zod_1.z.boolean().optional(),
    notes: zod_1.z
        .lazy(() => RequirementInstanceNote_1.RequirementInstanceNoteSchema)
        .array()
        .optional(),
    notesCount: zod_1.z.number().optional(),
    instanceMetadata: zod_1.z.lazy(() => RequirementInstanceResults_1.RequirementInstanceMetadataSchema).optional(),
    resultMetadata: zod_1.z.lazy(() => RequirementInstanceResults_1.RequirementInstanceResultMetadataSchema).optional(),
    designObjects: zod_1.z.lazy(() => DesignObject_1.DesignObjectSchema).array(),
});
//# sourceMappingURL=RequirementInstanceResult.js.map